/**
 * Le texte alternatif d'une photo produit — ce que Google lit, ce qu'un lecteur d'écran annonce, et ce que
 * l'acheteuse voit à la place de la photo quand celle-ci ne charge pas.
 *
 * Défaut du 17/09/2026 : la boîte cassée de la galerie affichait « usecases-FINAL.png ». Le tableau de
 * bord écrivait le NOM DE FICHIER de l'envoi dans `alt` (`alt: file.name`), donc toutes les photos des
 * produits déjà créés portent « hero-higgsfield-refine.png », « avis-v1.png », « comparaison-MOVE-4k.png ».
 * Le tableau de bord ne le fait plus, mais les fiches existantes portent toujours ces valeurs : la règle
 * est donc appliquée AUSSI à la lecture, sinon le défaut resterait visible sur toutes les boutiques déjà
 * en ligne jusqu'à ce que quelqu'un réédite chaque photo à la main.
 */
/**
 * Un `alt` qui n'est qu'un nom de fichier n'est pas un texte alternatif : c'est une valeur par défaut qui
 * a fui. On reconnaît l'extension, et l'absence d'espace — « Chemise en lin.jpg » reste une phrase écrite
 * par une vendeuse, maladroitement nommée ; « usecases-FINAL.png » n'en est pas une.
 */
const FILENAME = /^[^\s]+\.(?:png|jpe?g|webp|gif|avif|heic|heif|bmp|tiff?|svg)$/i;
export function looksLikeFileName(alt) {
    return FILENAME.test(alt.trim());
}
/**
 * Le texte à peindre : celui de la vendeuse s'il en est vraiment un, sinon le nom du produit — qui décrit
 * honnêtement la photo — sinon rien du tout.
 *
 * Rien du tout, c'est `''`, pas une phrase inventée : une `alt` vide dit « image décorative, passe ton
 * chemin » à un lecteur d'écran, ce qui vaut mieux que de lui faire épeler un nom de fichier. Et c'est
 * une chaîne, jamais `undefined` : sans attribut, certains lecteurs lisent l'URL à la place.
 */
export function productImageAlt(alt, productName) {
    const written = (alt ?? '').trim();
    if (written && !looksLikeFileName(written))
        return written;
    return (productName ?? '').trim();
}
//# sourceMappingURL=imageAlt.js.map